class ShopSideMenu extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('[data-shop-menu-overlay]');
    this.closeBtn = this.querySelector('[data-shop-menu-close]');
    this.tabs = this.querySelectorAll('[data-shop-menu-tab]');
    this.panels = this.querySelectorAll('[data-shop-menu-panel]');

    this.overlay.addEventListener('click', () => this.close());
    this.closeBtn.addEventListener('click', () => this.close());

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.setActiveTab(tab.dataset.shopMenuTab));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-open')) {
        this.close();
      }
    });

    // Any element on the page with [data-shop-menu-trigger] opens this menu,
    // but only on desktop. On mobile the click falls through so the theme's
    // existing mobile menu keeps working untouched.
    this.desktopQuery = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('[data-shop-menu-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (!this.desktopQuery.matches) return;
        event.preventDefault();
        this.open();
      });
    });
  }

  setActiveTab(handle) {
    this.tabs.forEach((tab) => {
      tab.classList.toggle('is-active', tab.dataset.shopMenuTab === handle);
    });
    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.shopMenuPanel === handle);
    });
  }

  open() {
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    this.closeBtn.focus();
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('shop-side-menu', ShopSideMenu);